import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { TweenMax } from "gsap"
import { ExternalLink } from "components"
import { ANIMATION } from "utils/constants"
import styles from "./button.module.scss"

const Button = ({
  content,
  index,
  modalIsOpen,
  setModalIsOpen,
  url,
  video,
}) => {
  const buttonRef = useRef()
  let btn

  const handleClick = () => {
    const buttonTag = buttonRef.current

    TweenMax.to(buttonTag, ANIMATION.DURATION, {
      autoAlpha: 0,
      ease: ANIMATION.EASE,
      scale: "5",
    })

    setModalIsOpen(!modalIsOpen)
  }

  useEffect(() => {
    const buttonTag = buttonRef.current

    if (!modalIsOpen && !url) {
      TweenMax.to(buttonTag, ANIMATION.DURATION, {
        autoAlpha: 1,
        ease: ANIMATION.EASE,
        scale: "1",
      })
    }
  })

  const animationDuration = Math.floor(Math.random() * 3) + 1.5

  const animationStyle = {
    animationDelay: `${index}s`,
    animationDuration: `${animationDuration}s`,
  }

  if (!url) {
    btn = (
      <button className={styles.button} onClick={handleClick} ref={buttonRef}>
        <span className={styles.buttonText} style={animationStyle}>
          {content}
        </span>
      </button>
    )
  } else {
    btn = (
      <ExternalLink className={styles.button} url={url}>
        <span className={styles.buttonText} style={animationStyle}>
          {!video && <div className={styles.buttonTextContent}>{content}</div>}
          {video && (
            <div className={styles.buttonCover}>
              <video
                autoPlay
                loop
                muted
                playsInline
                poster={video.coverSrc}
                preload="true"
              >
                <source src={video.videoSrc} type="video/mp4"></source>
              </video>
            </div>
          )}
        </span>
      </ExternalLink>
    )
  }

  return btn
}

Button.propTypes = {
  content: PropTypes.string.isRequired,
  index: PropTypes.number,
  modalIsOpen: PropTypes.bool,
  setModalIsOpen: PropTypes.func,
  url: PropTypes.string,
}

export default Button
